export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=2bffa07a"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=2bffa07a
// module id = T6WJ
// module chunks = 41